import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FileMetaData, FileService } from '../../../services/file/file.service';

@Component({
  selector: 'nw-file-preview',
  templateUrl: './file-preview.component.html',
  styleUrls: ['./file-preview.component.scss'],
})
export class FilePreviewComponent implements OnInit, OnDestroy {
  @Input() meta: FileMetaData;
  @Input() previewUrl?: string;

  uploadProgress: number | null = null;
  resolvedUrl: string | undefined;
  isModalOpen = false;
  private destroy$ = new Subject<void>();

  constructor(private readonly fileService: FileService) {}

  openModal() {
    if (this.resolvedUrl) {
      this.isModalOpen = true;
    }
  }

  closeModal() {
    this.isModalOpen = false;
  }

  ngOnInit() {
    this.resolvedUrl = this.previewUrl || this.fileService.getFileUrl(this.meta);

    const progress$ = this.fileService.getUploadProgress(this.meta.id);
    if (progress$) {
      progress$.pipe(takeUntil(this.destroy$)).subscribe({
        next: p => (this.uploadProgress = p),
        complete: () => (this.uploadProgress = null),
        error: () => (this.uploadProgress = null),
      });
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
